export default __webpack_public_path__ + "static/media/verificar-resultado-icon.9fbdd851.svg";